let originalMobileSlides = null;

function getMobileSwiper() {
  const mobile = document.querySelector('.product__media-container.below-mobile.carousel');
  return mobile?.swiper && !mobile.swiper.destroyed ? mobile.swiper : null;
}

function setLightboxEnabled(item, enabled) {
  if (enabled) {
    item.querySelectorAll('[data-lightbox-disabled]').forEach((el) => {
      el.classList.add('lightbox-image');
      el.removeAttribute('data-lightbox-disabled');
    });
  } else {
    item.querySelectorAll('.lightbox-image').forEach((el) => {
      el.classList.remove('lightbox-image');
      el.setAttribute('data-lightbox-disabled', '');
    });
  }
}

function moveFeaturedThumbFirst(thumbList, featuredMediaId) {
  if (!featuredMediaId || !thumbList) return;
  const featuredLi = thumbList.querySelector(`[data-thumbnail-id="${featuredMediaId}"]`)?.closest('li');
  if (featuredLi && thumbList.firstElementChild !== featuredLi) {
    thumbList.insertBefore(featuredLi, thumbList.firstElementChild);
  }
}

function applyDesktopFilter(matches, featuredMediaId) {
  const thumbList = document.querySelector('.product-thumbnails__items');
  if (thumbList) {
    thumbList.querySelectorAll('li').forEach((li) => {
      const thumb = li.querySelector('[data-thumbnail-id]');
      if (!thumb) return;
      const isFeatured = featuredMediaId && thumb.dataset.thumbnailId === String(featuredMediaId);
      const mediaItem = document.querySelector(`.product__media-item[data-media-item-id="${thumb.dataset.thumbnailId}"]`);
      const img = mediaItem?.querySelector('img');
      li.classList.toggle('pdp-color-hidden', !isFeatured && !matches(img?.getAttribute('alt') ?? ''));
    });

    moveFeaturedThumbFirst(thumbList, featuredMediaId);

    const featuredThumb = featuredMediaId ? thumbList.querySelector(`[data-thumbnail-id="${featuredMediaId}"]`) : null;
    (featuredThumb ?? thumbList.querySelector('li:not(.pdp-color-hidden) [data-thumbnail-id]'))?.click();
  }

  const desktop = document.querySelector('.product__media-container.above-mobile');
  if (!desktop) return;

  desktop.querySelectorAll('.product__media-item[data-media-item-id]').forEach((item) => {
    const isFeatured = featuredMediaId && item.dataset.mediaItemId === String(featuredMediaId);
    setLightboxEnabled(item, isFeatured || matches(item.querySelector('img')?.getAttribute('alt') ?? ''));
  });

  // Reorder desktop media items to match thumbnail order so lightbox index stays in sync
  if (featuredMediaId) {
    const mediaWrap = desktop.querySelector('.product__media');
    if (mediaWrap) {
      const featuredItem = mediaWrap.querySelector(`.product__media-item[data-media-item-id="${featuredMediaId}"]`);
      if (featuredItem && mediaWrap.firstElementChild !== featuredItem) {
        mediaWrap.insertBefore(featuredItem, mediaWrap.firstElementChild);
      }
    }
  }
}

function applyMobileFilter(matches, featuredMediaId) {
  const swiper = getMobileSwiper();
  if (!swiper) return;

  const wrapper = swiper.wrapperEl;

  // Save originals once — from real DOM slides, not Swiper's slide list (which may have loop clones)
  if (!originalMobileSlides) {
    originalMobileSlides = [...wrapper.children]
      .filter((s) => s.dataset.mediaItemId && !s.classList.contains('swiper-slide-duplicate'))
      .map((el) => el.cloneNode(true));
  }

  // Tear down loop so we can freely mutate the DOM without Swiper fighting us
  if (swiper.params.loop) swiper.loopDestroy();

  // Remove all real slides from DOM, then re-insert only matching ones
  wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').forEach((s) => s.remove());

  originalMobileSlides.forEach((orig) => {
    const isFeatured = featuredMediaId && orig.dataset.mediaItemId === String(featuredMediaId);
    const alt = orig.querySelector('img')?.getAttribute('alt') ?? '';
    if (isFeatured || matches(alt)) {
      const clone = orig.cloneNode(true);
      // Featured goes first
      if (isFeatured) {
        wrapper.insertBefore(clone, wrapper.firstChild);
      } else {
        wrapper.appendChild(clone);
      }
    }
  });

  // Rebuild loop clones and re-sync Swiper's internal slide list
  if (swiper.params.loop) swiper.loopCreate();
  swiper.update();
  swiper.slideTo(0, 0);
  swiper.pagination?.update();
  requestAnimationFrame(() => { swiper.slideTo(0, 0); swiper.pagination?.update(); });
}

function showAll(featuredMediaId) {
  const thumbList = document.querySelector('.product-thumbnails__items');
  if (thumbList) {
    thumbList.querySelectorAll('li').forEach((li) => li.classList.remove('pdp-color-hidden'));
    moveFeaturedThumbFirst(thumbList, featuredMediaId);
    const featuredThumb = featuredMediaId ? thumbList.querySelector(`[data-thumbnail-id="${featuredMediaId}"]`) : null;
    (featuredThumb ?? thumbList.querySelector('li [data-thumbnail-id]'))?.click();
  }

  document.querySelectorAll('.product__media-container.above-mobile .product__media-item[data-media-item-id]').forEach((item) => {
    setLightboxEnabled(item, true);
  });

  if (featuredMediaId) {
    const mediaWrap = document.querySelector('.product__media-container.above-mobile .product__media');
    if (mediaWrap) {
      const featuredItem = mediaWrap.querySelector(`.product__media-item[data-media-item-id="${featuredMediaId}"]`);
      if (featuredItem && mediaWrap.firstElementChild !== featuredItem) {
        mediaWrap.insertBefore(featuredItem, mediaWrap.firstElementChild);
      }
    }
  }

  const swiper = getMobileSwiper();
  if (swiper && originalMobileSlides) {
    const wrapper = swiper.wrapperEl;

    if (swiper.params.loop) swiper.loopDestroy();

    wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').forEach((s) => s.remove());

    originalMobileSlides.forEach((orig) => {
      const isFeatured = featuredMediaId && orig.dataset.mediaItemId === String(featuredMediaId);
      const clone = orig.cloneNode(true);
      if (isFeatured) {
        wrapper.insertBefore(clone, wrapper.firstChild);
      } else {
        wrapper.appendChild(clone);
      }
    });

    if (swiper.params.loop) swiper.loopCreate();
    swiper.update();
    swiper.slideTo(0, 0);
    swiper.pagination?.update();
    requestAnimationFrame(() => { swiper.slideTo(0, 0); swiper.pagination?.update(); });
  }
}

function filterGalleryByColor(color, featuredMediaId) {
  const lc = color.toLowerCase();
  const matches = (alt) => Boolean(alt) && alt.toLowerCase().includes(lc);

  const allImages = document.querySelectorAll('.product__media-item[data-media-item-id] img');
  const anyMatch = [...allImages].some((img) => matches(img.getAttribute('alt')));

  if (!anyMatch) {
    showAll(featuredMediaId);
    return;
  }

  applyDesktopFilter(matches, featuredMediaId);
  applyMobileFilter(matches, featuredMediaId);
}

function filterWhenReady(color, featuredMediaId) {
  const lc = color.toLowerCase();
  const matches = (alt) => Boolean(alt) && alt.toLowerCase().includes(lc);

  const allImages = document.querySelectorAll('.product__media-item[data-media-item-id] img');
  const anyMatch = [...allImages].some((img) => matches(img.getAttribute('alt')));

  if (!anyMatch) {
    // Still move featured first even when not filtering
    const thumbList = document.querySelector('.product-thumbnails__items');
    moveFeaturedThumbFirst(thumbList, featuredMediaId);
    const featuredThumb = featuredMediaId ? thumbList?.querySelector(`[data-thumbnail-id="${featuredMediaId}"]`) : null;
    (featuredThumb ?? thumbList?.querySelector('li [data-thumbnail-id]'))?.click();
  } else {
    applyDesktopFilter(matches, featuredMediaId);
  }

  // Mobile waits for Swiper
  const mobile = document.querySelector('.product__media-container.below-mobile.carousel');
  if (!mobile) return;

  if (mobile.swiper && !mobile.swiper.destroyed) {
    anyMatch ? applyMobileFilter(matches, featuredMediaId) : showAll(featuredMediaId);
    return;
  }

  const observer = new MutationObserver(() => {
    const swiper = getMobileSwiper();
    if (swiper) {
      observer.disconnect();
      anyMatch ? applyMobileFilter(matches, featuredMediaId) : showAll(featuredMediaId);
    }
  });
  // Swiper sets element.swiper (JS property, not DOM attr) and adds classes to child slides —
  // watch the subtree for class changes on slides (swiper-slide-active signals init is done)
  observer.observe(mobile, { subtree: true, attributes: true, attributeFilter: ['class'] });
}

document.addEventListener('product:variant-change', (e) => {
  const variant = e.detail?.variant;
  if (!variant?.option1) return;
  filterGalleryByColor(variant.option1, variant.featured_media?.id);
}, true);

const galleryFilterScript = document.querySelector('script[data-initial-color]');
const initialColor = galleryFilterScript?.dataset.initialColor;
const initialMediaId = galleryFilterScript?.dataset.initialMediaId;
if (initialColor) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => filterWhenReady(initialColor, initialMediaId));
  } else {
    filterWhenReady(initialColor, initialMediaId);
  }
}
